import { useRef as o, useState as T, useCallback as I, useEffect as M, useMemo as P } from "react";
import { searchLabelValues as j } from "../../../helpers/label-value/searchLabelValues.js";
import { highlightQueryInLabelValue as z } from "../../../helpers/label-value/highlightQueryInLabelValue.js";
function B(n, r, u, s) {
  var m = this, t = o(null), a = o(0), i = o(0), e = o(null), h = o([]), f = o(), v = o(), d = o(n), p = o(!0);
  d.current = n;
  var A = typeof window < "u", w = !r && r !== 0 && A;
  if (typeof n != "function") throw new TypeError("Expected a function");
  r = +r || 0;
  var S = !!(u = u || {}).leading, W = !("trailing" in u) || !!u.trailing, g = "maxWait" in u, b = "debounceOnServer" in u && !!u.debounceOnServer, y = g ? Math.max(+u.maxWait || 0, r) : null;
  M(function() {
    return p.current = !0, function() {
      p.current = !1;
    };
  }, []);
  var V = P(function() {
    var D = function(c) {
      var l = h.current, F = f.current;
      return h.current = f.current = null, a.current = c, i.current = i.current || c, v.current = d.current.apply(F, l);
    }, x = function(c, l) {
      w && cancelAnimationFrame(e.current), e.current = w ? requestAnimationFrame(c) : setTimeout(c, l);
    }, L = function(c) {
      if (!p.current) return !1;
      var l = c - t.current;
      return !t.current || l >= r || l < 0 || g && c - a.current >= y;
    }, O = function(c) {
      return e.current = null, W && h.current ? D(c) : (h.current = f.current = null, v.current);
    }, R = function c() {
      var l = Date.now();
      if (S && i.current === a.current && k(), L(l)) return O(l);
      if (p.current) {
        var F = r - (l - t.current), C = g ? Math.min(F, y - (l - a.current)) : F;
        x(c, C);
      }
    }, k = function() {
      s && s({});
    }, E = function() {
      if (A || b) {
        var c = Date.now(), l = L(c);
        if (h.current = [].slice.call(arguments), f.current = m, t.current = c, l) {
          if (!e.current && p.current) return a.current = t.current, x(R, r), S ? D(t.current) : v.current;
          if (g) return x(R, r), D(t.current);
        }
        return e.current || x(R, r), v.current;
      }
    };
    return E.cancel = function() {
      e.current && (w ? cancelAnimationFrame(e.current) : clearTimeout(e.current)), a.current = 0, h.current = t.current = f.current = e.current = null;
    }, E.isPending = function() {
      return !!e.current;
    }, E.flush = function() {
      return e.current ? O(Date.now()) : v.current;
    }, E;
  }, [S, g, r, y, W, w, A, b, s]);
  return V;
}
function G(n, r) {
  return n === r;
}
function H(n, r, u) {
  var s = G, m = o(n), t = T({})[1], a = B(I(function(e) {
    m.current = e, t({});
  }, [t]), r, u, t), i = o(n);
  return s(i.current, n) || (a(n), i.current = n), [m.current, a];
}
const Y = ({
  debounceThreshold: n = 500,
  initialOptions: r = [],
  options: u = [],
  query: s = ""
}) => {
  const [m, t] = T(!1), [a, i] = T(!1), [e, h] = T([]), [f] = H(s, n), v = o("");
  return M(() => {
    s && t(!0);
  }, [s]), M(() => {
    if (typeof u == "function") {
      J(
        v,
        f,
        u,
        h,
        t,
        i
      );
      return;
    }
    v.current !== f && (v.current = f, h(j(f, u)), t(!1), i(!1));
  }, [f, m, u]), {
    clearError: () => i(!1),
    debouncedQuery: f,
    error: a,
    loading: m,
    results: f ? e : r ?? [],
    stopSearch: () => {
      t(!1), i(!1);
    }
  };
}, J = async (n, r, u, s, m, t) => {
  if (n.current === r) return;
  if (n.current = r, !r) {
    m(!1), t(!1);
    return;
  }
  let a = !1;
  const i = await u(r).catch(
    (e) => (a = K(e), [])
  );
  s(
    i.map((e) => z(e, r))
  ), t(a), m(!1);
}, K = (n) => n instanceof Error && n.message ? n.message : typeof n == "string" ? n : !0;
export {
  Y as useAutocompleteSearch
};
